import $ from 'jquery';

export class Iframe {
    constructor(
        iframeStickyHeaderType,
        stickyHeaderWrapperId,
        stickyHeaderClass,
        pageName,
        componentName,
        logger
    ) {
        this.iframeStickyHeaderType = iframeStickyHeaderType;
        this.stickyHeaderWrapperId = stickyHeaderWrapperId;
        this.stickyHeaderClass = stickyHeaderClass;
        this.pageName = pageName;
        this.componentName = componentName;
        this.logger = logger;
        this.resizeIFrame();
    }

    resizeIFrame() {
        // check if page is within iframe
        if (typeof window !== 'undefined' && window?.self !== window?.top) {
            let lastHeight = 0;
            // check height of document
            const checkHeight = (callback) => {
                const extraPadding = 5;
                const pollingIntervalmillis = 1000;
                const rootElem = document.getElementById('root');
                const height = Math.max(rootElem?.scrollHeight, rootElem?.offsetHeight);
                const newHeight = height + extraPadding;

                if (lastHeight !== newHeight) {
                    callback(newHeight, () => {
                        lastHeight = newHeight;
                        setTimeout(() => checkHeight(callback), pollingIntervalmillis);
                    });
                } else {
                    setTimeout(() => checkHeight(callback), pollingIntervalmillis);
                }
            };

            // resize the iframe in parent window using post message API
            const resizeUsingPostMessageApi = (height) => {
                const targetWindow = window.parent;
                targetWindow.postMessage(
                    {
                        type: 'IFRAME_RESIZED',
                        height,
                        pageName: this.pageName,
                        componentName: this.componentName,
                    },
                    '*'
                );
            };

            // scroll the parent window using iframe navigation
            const scrollUsingPostMessageApi = (offsetTop) => {
                window.parent.postMessage(
                    { type: 'IFRAME_NAVIGATE', offsetTop, componentName: this.componentName },
                    '*'
                );
            };

            $(function () {
                // navigate to the section within iframe
                $('.nav-items a').on('click', function () {
                    const id = $(this).attr('data-key');
                    const offset = $(`#${id}`).offset();
                    // TODO: need to remove harcoded header height(138)
                    scrollUsingPostMessageApi(offset.top - 138);
                });

                // navigate to the section within iframe on link click
                $('.nav-link').on('click', function () {
                    const id = $(this).attr('data-key');
                    const offset = $(`#${id}`).offset();
                    // TODO: need to remove harcoded height(120)
                    scrollUsingPostMessageApi(offset.top + 120);
                });

                // check height of document and resize the iframe
                checkHeight((height, done) => {
                    resizeUsingPostMessageApi(height);
                    done();
                });

                $('#root')?.css('overflow-x', 'hidden');
            });
        }
    }

    navLinkChange(windowHeight, currentPos, headerHeight) {
        const navlinks = document.querySelectorAll('.nav-item');
        let stickyHeaderHeight = 0;

        if (this.iframeStickyHeaderType === 'Wrapper') {
            stickyHeaderHeight = $(`#${this.stickyHeaderWrapperId}`)?.outerHeight();
        } else if (this.iframeStickyHeaderType === 'Individual elements') {
            // get all individual sticky header elements
            const stickyElements = [
                ...$('*')
                    .children()
                    .filter(function () {
                        return (
                            $(this).css('position') === 'sticky' &&
                            $(this).hasClass(this.stickyHeaderClass)
                        );
                    }),
            ];

            if (stickyElements && stickyElements.length > 0) {
                // calculate sticky header height
                stickyElements.forEach((elem) => {
                    stickyHeaderHeight = stickyHeaderHeight + $(elem).outerHeight();
                });
            }
        }

        const sections = document.querySelectorAll('.section');
        let currentLink;

        sections.forEach((section) => {
            section.style['scroll-margin-top'] = `${stickyHeaderHeight}px`;
        });

        navlinks.forEach((link) => {
            const id = $(link).attr('data-key');
            const $section = $(`#${id}`);
            const sectionOffset = $section[0].offsetTop - (headerHeight + 18);

            // check if section being displayed
            if (currentPos >= sectionOffset && sectionOffset < currentPos + windowHeight) {
                currentLink = link;
            }
        });

        // add active class
        $(navlinks).removeClass('active');
        $(currentLink).addClass('active');
    }

    makeUpdates(e) {
        this.logger.debug('make update', e);

        if (e.data && e.data.type === 'PARENT_SCROLL') {
            const windowHeight = e.data.windowHeight;
            const scrollFromTop = e.data.scrollFromTop;
            const parentHeaderHeight = e.data.headerHeight;

            // TODO: Fix adding hardcoded height(18) to headerHeight
            const headerHeight = parentHeaderHeight + 18;

            // show and hide minimized header on scroll
            if (scrollFromTop > parentHeaderHeight) {
                $('#header-section').css('display', 'none');
                $('#minimized-header').css('display', 'block');
            } else {
                $('#header-section').css('display', 'block');
                $('#minimized-header').css('display', 'none');
            }

            if (this.iframeStickyHeaderType === 'Wrapper') {
                const topElem = $(`#${this.stickyHeaderWrapperId}`);

                if (topElem) {
                    if (scrollFromTop > parentHeaderHeight) {
                        // assign top to wrapper element
                        topElem.css('top', `${scrollFromTop - headerHeight}px`);
                    } else {
                        topElem.css('top', '0px');
                    }
                }
            } else if (this.iframeStickyHeaderType === 'Individual elements') {
                const stickyElements = [
                    ...$('*')
                        .children()
                        .filter(
                            $.proxy(function (index, el) {
                                return (
                                    $(el).css('position') === 'sticky' &&
                                    $(el).hasClass(this.stickyHeaderClass) &&
                                    $(el).css('display') !== 'none'
                                );
                            }, this)
                        ),
                ];

                if (
                    scrollFromTop > parentHeaderHeight &&
                    stickyElements &&
                    stickyElements.length > 0
                ) {
                    this.logger.debug(
                        'scrollFromTop, parentHeaderHeight',
                        scrollFromTop,
                        parentHeaderHeight
                    );
                    $(stickyElements[0]).css('top', `${scrollFromTop - headerHeight}px`);
                    const elemPrevDisplay = $(stickyElements[0]).css('display');
                    $(stickyElements[0]).css('display', 'none');
                    $(stickyElements[0]).css('offsetHeight');
                    $(stickyElements[0]).css('display', elemPrevDisplay);

                    stickyElements.forEach((elem, i) => {
                        if (i > 0) {
                            // calculate all previous element height
                            let prevElemHeight = 0;
                            stickyElements
                                .slice(0, i)
                                .forEach(
                                    (e) => (prevElemHeight = prevElemHeight + $(e).outerHeight())
                                );
                            // assing top to sticky element
                            $(stickyElements[i]).css(
                                'top',
                                `${scrollFromTop - headerHeight + prevElemHeight}px`
                            );

                            const elemPrevDisplay = $(stickyElements[i]).css('display');
                            $(stickyElements[i]).css('display', 'none');
                            $(stickyElements[i]).css('offsetHeight');
                            $(stickyElements[i]).css('display', elemPrevDisplay);
                        }
                    });
                } else {
                    $(stickyElements[0]).css('top', '0px');
                    stickyElements.forEach((elem, i) => {
                        if (i > 0) {
                            $(stickyElements[i]).css(
                                'top',
                                `${$(stickyElements[i - 1]).outerHeight()}px`
                            );
                        }
                    });
                }
            }

            this.navLinkChange(windowHeight, scrollFromTop, parentHeaderHeight);
        }
    }
}
